import { render, staticRenderFns } from "./CommentsReportPopover.vue?vue&type=template&id=1ba22b31&scoped=true"
import script from "./CommentsReportPopover.vue?vue&type=script&lang=js"
export * from "./CommentsReportPopover.vue?vue&type=script&lang=js"
import style0 from "./CommentsReportPopover.vue?vue&type=style&index=0&id=1ba22b31&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ba22b31",
  null
  
)

export default component.exports